import clsx from 'clsx';

import { eventService, XApiEventKeys } from 'shared/api/event-service';
import { QuestionMarkIcon } from 'shared/ui/icons';
import { useAppDispatch } from 'shared/lib/redux';
import {
  setIsWalkthroughActivatedManually,
  WT_PROGRAMS_COLLAPSE_ANIMATION_DURATION,
} from 'features/walkthrough';

import styles from './styles.module.scss';

type WalkthroughAccessButtonProps = {
  classNames?: string;
};

export const WalkthroughAccessButton = ({
  classNames,
}: WalkthroughAccessButtonProps) => {
  const dispatch = useAppDispatch();

  const handleXApiEvent = (isRightClick = false) => {
    eventService.send(XApiEventKeys.launchedWalkthrough, undefined, {
      result: {
        isRightClick,
      },
    });
  };

  const handleWalkthroughAccessBtnClick = () => {
    dispatch(setIsWalkthroughActivatedManually(true));

    // trigger highlighted area recalculation after Programs section collapse
    setTimeout(() => {
      dispatchEvent(new Event('resize'));
    }, WT_PROGRAMS_COLLAPSE_ANIMATION_DURATION);

    handleXApiEvent();
  };

  const handleContextMenu = () => handleXApiEvent(true);

  return (
    <button
      aria-label="Start Walkthrough"
      onClick={handleWalkthroughAccessBtnClick}
      onContextMenu={handleContextMenu}
      className={clsx(styles.walkthroughAccessBtn, classNames)}
    >
      <QuestionMarkIcon />
    </button>
  );
};
